export default __webpack_public_path__ + "static/media/aws-waf.b53ed32f.svg";